import { render, staticRenderFns } from "./RepartitionGeoChart.vue?vue&type=template&id=0c8a24fe&scoped=true"
import script from "./RepartitionGeoChart.vue?vue&type=script&lang=js"
export * from "./RepartitionGeoChart.vue?vue&type=script&lang=js"
import style0 from "./RepartitionGeoChart.vue?vue&type=style&index=0&id=0c8a24fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a24fe",
  null
  
)

export default component.exports